import { render, staticRenderFns } from "./NaturalPersonAndSPForm.vue?vue&type=template&id=561af76d&"
import script from "./NaturalPersonAndSPForm.vue?vue&type=script&lang=js&"
export * from "./NaturalPersonAndSPForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports